export var VariableType;
(function (VariableType) {
    VariableType[VariableType["Boolean"] = 1] = "Boolean";
    VariableType[VariableType["String"] = 2] = "String";
    VariableType[VariableType["Numeric"] = 3] = "Numeric";
    VariableType[VariableType["Date"] = 4] = "Date";
    VariableType[VariableType["Time"] = 5] = "Time";
    VariableType[VariableType["Link"] = 6] = "Link";
    VariableType[VariableType["Array"] = 7] = "Array";
})(VariableType || (VariableType = {}));
export default VariableType;
//# sourceMappingURL=variable-type.js.map